import React, { useCallback, useContext, useMemo, useState } from 'react';
import { Button, Dropdown, message, Tooltip } from 'antd';
import { ControlOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ServiceRequestData } from '@services/types/Relationship/MyCalls/types';
import SessionContext from '@providers/Session/SessionContext';
import api from '@services/api';

export type MessagesActionNames = 'CLOSE' | 'CLOSE.UNFOUNDED';

interface MessagesActionsProps {
  request?: ServiceRequestData;
  onMutateRequest?: (action: MessagesActionNames, requestId: number) => void;
}

const MessagesActions = ({
  request,
  onMutateRequest,
}: MessagesActionsProps) => {
  const { t } = useTranslation('service-requests');
  const {
    userLogged,
    customer: { customerLogged },
  } = useContext(SessionContext);
  const [actionLoading, setActionLoading] = useState(false);

  const isRoot = customerLogged?.type === 'ROOT';

  const executeAction = useCallback(
    async (actionName: MessagesActionNames) => {
      setActionLoading(true);
      const isActionClose = actionName === 'CLOSE';
      try {
        let note = 'Solicitação cancelada';

        if (isActionClose) {
          note = 'Solicitação encerrada';
        }

        await api.post(
          'service-proxy/service/request/executeActionServiceRequest',
          {
            serviceRequestId: request?.id,
            actionName,
            user: userLogged?.preferred_username,
            worklogs: [
              {
                note,
                restrictionType: { id: 1, name: 'VISIVEL PARA TODOS' },
              },
            ],
          },
          { params: { assetId: request?.asset?.assetNumber } },
        );
        message.success(
          t(
            `msgs.${
              isActionClose
                ? 'requestClosedSuccessfully'
                : 'requestCancelledSuccessfully'
            }`,
          ),
        );
        onMutateRequest?.(actionName, request?.id ?? 0);
      } catch {
        message.error(
          t(
            `msgs.${
              isActionClose ? 'errorClosingRequest' : 'errorCancelingRequest'
            }`,
          ),
        );
      }
      setActionLoading(false);
    },
    [
      onMutateRequest,
      request?.asset?.assetNumber,
      request?.id,
      t,
      userLogged?.preferred_username,
    ],
  );

  const dropdownItems = useMemo(
    () =>
      [
        {
          key: 'close',
          label: t('buttons.close'),
          onClick: () => executeAction('CLOSE'),
          visible: isRoot,
        },
        // {
        //   key: 'cancel',
        //   label: t('buttons.cancel'),
        //   onClick: () => executeAction('CLOSE.UNFOUNDED'),
        //   visible: true,
        // },
      ]?.filter(item => item.visible),
    [executeAction, isRoot, t],
  );

  return (
    <Dropdown menu={{ items: dropdownItems }}>
      <Tooltip title={t('actions')}>
        <Button
          type="primary"
          icon={<ControlOutlined />}
          style={{ marginLeft: 8 }}
          loading={actionLoading}
        />
      </Tooltip>
    </Dropdown>
  );
};

export default MessagesActions;
